import { Component, Vue, Watch } from 'vue-property-decorator';
import * as T_T from 'cryface';
import { CommonConfig } from '../../configs/config.common';

@Component
export default class Banner extends Vue {
   public title: string = 'Banner';

   public configs = new CommonConfig();

   public style = { 'background-image': 'url(' + new CommonConfig().bannerHolder + ')' };

   @Watch('$store.state.auth.userInfo', { immediate: true, deep: true })
   public onUserChanged(val: any, oldVal: any) {
      const slogan = T_T.simpleDetect(val.value.agentBannerUrl) ?
         val.value.agentBannerUrl : this.configs.bannerHolder;
      this.style = { 'background-image': 'url(' + slogan + ')' };
   }
}
